import { Base } from '../base-component';
import './image-with-text-block.component.scss';

export class ImageWithTextBlock extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){

	}

	bindEvents() {

	}

}


// WEBPACK FOOTER //
// ./components/image-with-text-block/image-with-text-block.component.ts